import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/groups/{slug}/follow-ups` is a redirect, not a screen.
 *
 * Legacy's `WBS_Group_Extension::load_default_subnav_screen` (`:329-335`) 302s
 * the bare tab slug to the FIRST registered subnav whenever no action variable
 * follows it, and Follow-up Requests is first on this extension
 * (`class-study-group-follow-up.php:22-36`). Without this the route renders the
 * tab bar over an empty outlet.
 *
 * This is the opposite of the member tab's answer
 * (`_users.members/$memberId.follow-ups.index.tsx`), deliberately: that tab has
 * a real index screen, while this one's `overview.php` is an `echo __FILE__;`
 * debug stub reachable from no registered subnav.
 *
 * `beforeLoad`, not a component effect — the answer needs no payload, so
 * bouncing before the subtree mounts avoids a frame of empty tab body.
 *
 * Only the BARE slug. Legacy's `templateNotFound()` (`:341-346`) also redirects
 * any unrecognised slug under the tab, and that is deliberately not built: a
 * catch-all splat is a second routing mechanism for a URL nobody navigates to
 * (W3.9 N9).
 */
export const Route = createFileRoute(
  '/_app/_dashboard/groups/$groupName/follow-ups/',
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/groups/$groupName/follow-ups/follow-up-requests/',
      params: { groupName: params.groupName },
      replace: true,
    });
  },
});
